import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { catalogTypeToSuitableClientType } from '@common/utils/catalogType';
import { ClientType } from '@common/model/client/clientType';
import { CLIENT_EMPLOYER_DEFAULT_NAME } from '@common/const/client/defaults';
import { ClientSelection } from 'src/entities/client';

export const mapCatalogItemToClientSelection = (catalogItem: CatalogItemViewModel): ClientSelection => {
  const clientType = catalogTypeToSuitableClientType(catalogItem.type);

  return {
    catalogType: catalogItem.type,
    careerId: catalogItem.careerId,
    cityId: catalogItem.city?.id,
    name: clientType === ClientType.Employer ? CLIENT_EMPLOYER_DEFAULT_NAME : undefined,
  };
};
